/**
 * noook play — Content Protection
 * Prevents casual right-click, text selection, and copy on images/content.
 * Deterrent only — not DRM. Does not block accessibility tools.
 * Toggle: settings.content_protection_enabled in settings_schema.json.
 */

(function () {
  // Disable right-click context menu on images and product content
  document.addEventListener('contextmenu', function (e) {
    if (e.target.tagName === 'IMG' || e.target.closest('.product__media-wrapper, .product-gallery, .product-card__media')) {
      e.preventDefault();
    }
  });

  // Disable image drag
  document.addEventListener('dragstart', function (e) {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
    }
  });

  // Apply user-select: none to product media via CSS class
  document.querySelectorAll('.product-gallery, .product-card__media, .hero-banner__media').forEach(function (el) {
    el.style.userSelect = 'none';
    el.style.webkitUserSelect = 'none';
  });
})();
